import { render, staticRenderFns } from "./CreateBrand.vue?vue&type=template&id=4e4a0853&scoped=true&"
import script from "./CreateBrand.vue?vue&type=script&lang=js&"
export * from "./CreateBrand.vue?vue&type=script&lang=js&"
import style0 from "./CreateBrand.vue?vue&type=style&index=0&id=4e4a0853&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4a0853",
  null
  
)

export default component.exports